<template>
	<booking :data="booking" v-if="booking !== null" />
</template>

<script>
import Booking from '~/views/components/booking'
export default {
	name: 'Show',
	layout: 'index',

	components: { Booking },

	metaInfo() {
		return { title: this.$t('pages.booking') }
	},

	data() {
		return {
			booking: null,
		}
	},

	computed: {
		date() {
			return this.$moment(this.booking.date)
		},
	},

	async created() {
		try {
			let { data } = await this.$http.get(this.$route.fullPath)
			this.booking = data
		} catch ({ response }) {
			this.$modal('errors/error', { text: response.data.message })
		}
	},

	methods: {
		async cancel() {
			let { data } = await this.$http.delete(this.booking.cancel_url)
			this.booking = data
		},
	},
}
</script>
